import styled from 'styled-components';

import { PagesHeading } from '../../../../../../CommonComponents/commonStyles';

export const ContributionsHead = styled(PagesHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media (min-width: 320px) and (max-width: 768px) {
    font-size: ${props => props.theme.fontSize.h2};
  }
`;
